module.exports = __webpack_public_path__ + "media/headline.e3f59650.mp3";